<script>
    export let data = {}
    const { content, props } = data
</script>

<div class="modal-content">
    <svelte:component this={content} {...props} />
</div>
